import { useState, useEffect, useRef } from "react";
import { getCotizacion } from "../../service/AffariService";
import Cabecera from "./components/Cabecera";
import { useNavigate } from "react-router-dom";
import ContactoDialog from "../../components/dialogs/ContactoDialog";
import DatosDialog from "../../features/clientes/components/DatosDialog";
import DeudaDialog from "../../features/clientes/components/DeudaDialog";
import VentaDialog from "../../features/clientes/components/VentaDialog";
import TicketsDialog from "../../features/clientes/components/TicketsDialog";
import HeaderSteps from "../../components/ui/Steps";
import { Button } from 'primereact/button';
import { Panel } from 'primereact/panel';
import { Toast } from 'primereact/toast';
import DetalleCotizacion from "./components/DetalleCotizacion";

const Cotizacion = (props) => {
    const navigate = useNavigate();
    const [codigo, setCodigo] = useState('');
    const [tipo, setTipo] = useState('');
    const [data, setData] = useState({});
    const [isDetalleVisible, setIsDetalleVisible] = useState(false);
    const [isContactoDialogVisible, setIsContactoDialogVisible] = useState(false);
    const [isDatosDialogVisible, setIsDatosDialogVisible] = useState(false);
    const [isDeudaDialogVisible, setIsDeudaDialogVisible] = useState(false);
    const [isVentaDialogVisible, setIsVentaDialogVisible] = useState(false);
    const [isTicketsDialogVisible, setIsTicketsDialogVisible] = useState(false);
    const [collapsedClient, setCollapsedClient] = useState(false);
    const [collapsedFolio, setCollapsedFolio] = useState(false);
    const [idCotizacion, setIdCotizacion] = useState('');
    const toast = useRef(null);

    useEffect(() => {
        const { codigo: codigoParam, tipo: tipoParam } = props.location.search.split('?')[1].split('&').reduce((acc, item) => {
        const [key, value] = item.split('=');
        acc[key] = value;
        return acc;
        }, {});

        setCodigo(codigoParam);
        setTipo(tipoParam);

        if (codigoParam) {
            (async () => {
                try {
                    const data = await getCotizacion(codigoParam);
                    if (data) {
                        if (!data.estado && data.estados && data.estados.length > 0) {
                            data.estado = data.estados[0];
                        }
                        if (tipoParam === 'boleta') {
                            data.documento = 'Boleta';
                        }
                        if (tipoParam === 'factura') {
                            data.documento = 'Factura';
                        }
                        if (data.contactos && data.contactos.length > 0 && !data.contacto) {
                            data.contacto = data.contactos[0];
                        }
                        setData(data);
                    }
                } catch (error) {
                    console.error("Error al cargar la cotización:", error);
                }
            })();
        }
    }, []);

    const handleContactosChange = (lista) => {
        setData((prevData) => {
            const contactos = Array.isArray(lista) ? lista : [];
            let contacto = prevData.contacto;
            if (contacto?.id) {
                const match = contactos.find((item) => item.id === contacto.id);
                if (match) {
                    contacto = match;
                }
            }
            if (!contacto && contactos.length > 0) {
                contacto = contactos[0];
            }
            return { ...prevData, contactos, contacto };
        });
    };

    return (
        <>
            <Toast ref={toast} position="top-right" appendTo={document.body} baseZIndex={4000} />

            {/* sub titulo */}
            <div className="flex flex-column md:flex-row md:align-items-center md:justify-content-between py-0">
                <div className="flex align-items-center">
                    <Button
                        type="button"
                        className="p-button-rounded p-button-text text-600"
                        icon="pi pi-arrow-left"
                        onClick={() => navigate(`/${tipo}`)}
                        tooltip="Volver"
                    />
                    <h4 className="m-0 text-lg">Ingreso de Cotización {tipo === 'boleta' ? 'Boleta' : 'Factura'}</h4>
                </div>
                <HeaderSteps activeIndex={1} />
            </div>

            {/* cotizacion */}
            <div className="p-fluid">
                {/* cabecera cliente */}
                <Panel header={ <div className="flex align-items-center py-2"> <div className="surface-100 border-circle w-3rem h-3rem flex align-items-center justify-content-center mr-3"> <i className="pi pi-user text-primary text-xl"></i> </div><span className="text-xl font-medium text-900"> {`Cliente ${data.interfaz === 'MAYORISTA' ? 'Mayorista' : 'Retail'}`}</span></div> } toggleable collapsed={collapsedClient} onToggle={(e) => setCollapsedClient(e.value)} className="border-none shadow-1 border-round-xl overflow-hidden surface-card">
                    <div className="p-2">
                        <Cabecera
                            tipo={tipo}
                            data={data}
                            setData={setData}
                            setCodigo={setCodigo}
                            setIdCotizacion={setIdCotizacion}
                            setIsDetalleVisible={setIsDetalleVisible}
                            setIsContactoDialogVisible={setIsContactoDialogVisible}
                            setIsDatosDialogVisible={setIsDatosDialogVisible}
                            setIsDeudaDialogVisible={setIsDeudaDialogVisible}
                            setIsVentaDialogVisible={setIsVentaDialogVisible}
                            setIsTicketsDialogVisible={setIsTicketsDialogVisible}
                            setCollapsedClient={setCollapsedClient}
                            setCollapsedFolio={setCollapsedFolio}
                            toastRef={toast}
                        />
                    </div>
                </Panel>
            </div>
            
            <div className="p-fluid mt-2">
                {/* detalle de la cotizacion */}
                { isDetalleVisible && (
                    <Panel header={<div className="flex align-items-center py-2"><div className="surface-100 border-circle w-3rem h-3rem flex align-items-center justify-content-center mr-3"> <i className="pi pi-file text-primary text-xl"></i> </div><span className="text-xl font-medium text-900"> {`Folio: #${idCotizacion}`}</span></div> } toggleable collapsed={collapsedFolio} onToggle={(e) => setCollapsedFolio(e.value)} className="border-none shadow-1 border-round-xl overflow-hidden surface-card">
                        <DetalleCotizacion
                            tipo= {data.interfaz}
                            idCotizacion={idCotizacion}
                            data={data}
                            setData={setData}
                            isDetalleVisible={isDetalleVisible}
                            setIsDetalleVisible={setIsDetalleVisible}
                        />
                    </Panel>
                )}            
            </div>

            {/* ventanas dialog */}
            <ContactoDialog 
                visible={isContactoDialogVisible} 
                onHide={() => setIsContactoDialogVisible(false)} 
                data={data}
                onContactosChange={handleContactosChange}
            />

            <DatosDialog
                visible={isDatosDialogVisible}
                onCancel={() => { setIsDatosDialogVisible(false); }}
                codigo={codigo}
            />

            <DeudaDialog
                visible={isDeudaDialogVisible}
                onCancel={() => { setIsDeudaDialogVisible(false); }}
                codigo={codigo}
            />

            <VentaDialog
                visible={isVentaDialogVisible}
                onCancel={() => { setIsVentaDialogVisible(false); }}
                codigo={codigo}
            />

            <TicketsDialog
                visible={isTicketsDialogVisible}
                onCancel={() => { setIsTicketsDialogVisible(false); }}
                codigo={codigo}
            />
        </>
    );
};

export default Cotizacion;